const HISTORY_STORAGE_KEY = "FIREBOLT_aiPromptHistory";
const DRAFT_STORAGE_KEY = "FIREBOLT_aiPromptHistoryDraft";
const MAX_HISTORY_ENTRIES = 50;

function readRawHistory(): unknown {
  try {
    const raw = window.localStorage.getItem(HISTORY_STORAGE_KEY);
    return raw ? JSON.parse(raw) : [];
  } catch (e) {
    return [];
  }
}

function writeRawHistory(entries: string[]): void {
  window.localStorage.setItem(HISTORY_STORAGE_KEY, JSON.stringify(entries));
}

export function getAiPromptHistory(): string[] {
  const raw = readRawHistory();
  if (!Array.isArray(raw)) return [];
  const normalized = raw
    .filter(item => typeof item === "string")
    .map(item => item.trim())
    .filter(item => item.length > 0);
  // Ensure we never exceed the cap when reading
  return normalized.length > MAX_HISTORY_ENTRIES
    ? normalized.slice(normalized.length - MAX_HISTORY_ENTRIES)
    : normalized;
}

export function addPromptToHistory(prompt: string): string[] {
  const value = (prompt || "").trim();
  if (!value) return getAiPromptHistory();

  const history = getAiPromptHistory();
  const last = history[history.length - 1];
  if (last === value) return history;

  const next = [...history, value];
  const trimmed =
    next.length > MAX_HISTORY_ENTRIES
      ? next.slice(next.length - MAX_HISTORY_ENTRIES)
      : next;
  writeRawHistory(trimmed);
  return trimmed;
}

export function clearAiPromptHistory(): void {
  try {
    window.localStorage.removeItem(HISTORY_STORAGE_KEY);
  } catch (e) {
    console.error("Error clearing AI prompt history", e);
  }
}

export function getAiPromptHistoryCapacity(): number {
  return MAX_HISTORY_ENTRIES;
}

export function getAiPromptDraft(): string {
  try {
    const raw = window.localStorage.getItem(DRAFT_STORAGE_KEY);
    if (!raw) return "";
    const value = JSON.parse(raw);
    return typeof value === "string" ? value : "";
  } catch (e) {
    console.error("Error getting AI prompt draft", e);
    return "";
  }
}

export function setAiPromptDraft(value: string): void {
  try {
    window.localStorage.setItem(DRAFT_STORAGE_KEY, JSON.stringify(value ?? ""));
  } catch (e) {
    console.error("Error setting AI prompt draft", e);
  }
}

export function clearAiPromptDraft(): void {
  try {
    window.localStorage.removeItem(DRAFT_STORAGE_KEY);
  } catch (e) {
    console.error("Error clearing AI prompt draft", e);
  }
}
